// @ts-nocheck

import type { SelectProps } from 'antd/lib/select';
import React from 'react';
import { accessTypes } from '../../lib/enum';
import { Option, Select } from './../ant/Select';
import {
  getLabeledSelectValue,
  toLabeledSelectValue,
} from './labelInValue';

type AccessKey = keyof typeof accessTypes;

type AccessOption = {
  value: AccessKey;
  label: string;
};

type Props = Omit<SelectProps, 'value' | 'onChange'> & {
  value?: AccessKey[];
  onChange?: (value: AccessKey[]) => void;
};

const accessKeys = Object.keys(accessTypes) as AccessKey[];

export default function UserAccessTypesSelect({
  value,
  onChange,
  ...selectProps
}: Props) {
  return (
    <Select
      placeholder="Выберите доступы"
      showSearch
      optionFilterProp="label"
      mode="multiple"
      labelInValue
      {...selectProps}
      value={(value || []).map((key) =>
        toLabeledSelectValue(key, accessTypes[key])
      )}
      onChange={(selected: AccessOption[]) => {
        onChange?.(selected.map(getLabeledSelectValue));
      }}
      allowClear
    >
      {accessKeys.map((key) => (
        <Option key={key} value={key} label={accessTypes[key]}>
          {accessTypes[key]}
        </Option>
      ))}
    </Select>
  );
}
